import { gql } from "@apollo/client";

export const CONTACT_ADMIN = gql`
  mutation sendContactMail($input: contactInput!) {
    sendContactMail(input: $input)
  }
`;
